import React, { useState, useEffect } from 'react';
import Landing from './pages/Landing';
import Test from './pages/Test';
import EmailCapture from './pages/EmailCapture';
import Results from './pages/Results';
import Unsubscribe from './pages/Unsubscribe';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Impressum from './pages/Impressum';
import CookieBanner from './components/CookieBanner';
import './App.css';

function getPage() {
  const path = window.location.pathname;
  if (path === '/abbestellen') return 'unsubscribe';
  if (path === '/datenschutz')  return 'privacy';
  if (path === '/impressum')    return 'impressum';
  if (path === '/abbestellen')  return 'unsubscribe';
  return 'home';
}

export default function App() {
  const [page, setPage]       = useState('landing');
  const [result, setResult]   = useState(null);
  const [email, setEmail]     = useState('');
  const [tracking, setTracking] = useState({ cid: '', uid: '' });
  const [cookieConsent, setCookieConsent] = useState(null); // null=unknown, true=accepted, false=declined
  const section = getPage();

  useEffect(() => {
    // Read tracking params from URL, persist in sessionStorage
    const params = new URLSearchParams(window.location.search);
    const cid = params.get('cid') || sessionStorage.getItem('cid') || '';
    const uid = params.get('uid') || sessionStorage.getItem('uid') || '';
    if (cid) sessionStorage.setItem('cid', cid);
    if (uid) sessionStorage.setItem('uid', uid);
    setTracking({ cid, uid });

    // Check existing consent
    const saved = localStorage.getItem('cookie_consent');
    if (saved !== null) setCookieConsent(saved === 'true');

    // Track visitor
    fetch('/api/track.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: window.location.pathname + window.location.search,
        referer: document.referrer,
        cid, uid,
        lang: navigator.language,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
        screen: `${window.screen.width}x${window.screen.height}`,
        event: 'pageview'
      })
    }).catch(() => {});
  }, []);

  const handleConsent = (accepted) => {
    setCookieConsent(accepted);
    localStorage.setItem('cookie_consent', accepted ? 'true' : 'false');
    localStorage.setItem('cookie_consent_date', new Date().toISOString());
  };

  // Route static pages
  if (section === 'unsubscribe') return <Unsubscribe />;
  if (section === 'privacy')     return <PrivacyPolicy />;
  if (section === 'impressum')   return <Impressum />;

  return (
    <div className="app">
      {page === 'landing'  && <Landing onStart={() => setPage('test')} />}
      {page === 'test'     && <Test onComplete={(res) => { setResult(res); setPage('capture'); }} />}
      {page === 'capture'  && (
        <EmailCapture
          result={result}
          tracking={tracking}
          cookieConsent={cookieConsent}
          onSubmit={(em) => { setEmail(em); setPage('results'); }}
        />
      )}
      {page === 'results'  && <Results result={result} email={email} />}

      {/* Cookie banner — show if consent not yet given */}
      {cookieConsent === null && <CookieBanner onAccept={() => handleConsent(true)} onDecline={() => handleConsent(false)} />}
    </div>
  );
}
